import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box } from "@material-ui/core";

import useStyles, {
  aboutDrawerWidth,
} from "../Styles";

const CentralAZSidebarChart = ({ chartData }) => {
  const classes = useStyles();

  Highcharts.setOptions({
    chart: {
        style: {
            fontFamily: 'Arial'
        }
    }
});


  
  const options = {
    chart: {
      type: "bar",
      plotBackgroundColor: "transparent",
      backgroundColor: "transparent",
      width: aboutDrawerWidth - 10,
      fontFamily: 'Arial'
    },
    title: {
      text: null,
    },
    xAxis: {
      categories: chartData?.categories,
      title: {
        text: null,
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "(acre-feet)",
        /* align: 'high' */
      },
      labels: {
        overflow: "justify",
      },
      gridLineColor: "#FFF",
    },
    series: [
      {
        // name: "Year 1990",
        data: chartData?.data,
      },
    ],
    credits: {
      enabled: false,
    },

    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true,
          align: 'right',
          padding: 10,
          formatter: function () {
            const yVal = this.y;
            return yVal.toLocaleString("en-US");
          },
          style: {
            color: "#000000", // Set consistent font color for bar data labels
          },
        },
        states: {
          hover: {
            enabled: false,
          },
          inactive: {
            opacity: 1,
          },
        },
        borderWidth: 0,
        showInLegend: false,
        colorByPoint: true,
      },
      series: {
        point: {
          events: {
            legendItemClick: function () {
              return false; // <== returning false will cancel the default action
            },
          },
        },
      },
    },
    colors: ["#01665E", "#5AB4AC", "#C7EAE5", "#D8B365", "#8C510A"],
    tooltip: {
      enabled: false,
    },
  };

  return (
    <Box className={classes.chartContainer}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Box>
  );
};
export default CentralAZSidebarChart;
